import React from 'react';
import {Link} from 'react-router-dom';

// import addButton from '../../../../icons/add.svg';
// import addBtn from '../../../../icons/addFile.svg';
import addBttn from '../../../../icons/addSquares.svg';

import classes from './AddDropButton.css';

const addDropButton = props => {

    let dropButtonStyle = [classes.AddDropButton];

    if (props.disabled) {
        dropButtonStyle.push(classes.Disabled);
    }

    return (        
        <Link to={props.linkName} >
            <img src={addBttn} className={dropButtonStyle.join(' ')} alt="Error 404"/>
        </Link>
    )
}

export default addDropButton;


// WEBPACK FOOTER //
// ./src/components/UI/Buttons/AddDropButton/AddDropButton.js